window.timerDiscrepancyFromAPI = 3; // 3 sec is the discrepancy I noticed for price timer from API
window.promoTimerRunningAllowancePeriod = 20; // 30 sec to check if we sill productModule.startPromoTimers()

$(document).ready(function() {
  $('body').on('click', '.print', function(e) {
    console.log('print clicked');
    e.preventDefault();
    window.print();
  });

  $('.socila-media-share').on('click', function(e) {
    e.preventDefault();
    var $link = $(this);
    var href = $link.attr('href');
    var socialMedia = $link.attr('data-sm');

    var socialMedias = {
      facebook: {
        width: 600,
        height: 300
      },
      twitter: {
        width: 600,
        height: 254
      },
      google: {
        width: 515,
        height: 490
      },
      linkedin: {
        width: 600,
        height: 473
      },
      pinterest: {
        width: 600,
        height: 473
      }
    };

    var popup = function(socialMedia) {
      var options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';
      window.open(href, '', options + 'height=' + socialMedias[socialMedia].height + ',width=' + socialMedias[socialMedia].width);
    }

    popup(socialMedia);
  });
});

Object.size = function(obj) {
  var size = 0,
    key;
  for (key in obj) {
    if (obj.hasOwnProperty(key)) size++;
  }
  return size;
};

function isFirefox() {
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}

function isSamsungInternet() {
  return navigator.userAgent.match(/SamsungBrowser/i);
}

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
function detectIE() {
  var ua = window.navigator.userAgent;

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}

function getUrlVars() {
  return Object.fromEntries(new URLSearchParams(window.location.search).entries());
}

function commaSeparateNumber(val) {
  if (isAuctionsOverview()) {
    val = parseInt(val);
  }

  while (/(\d+)(\d{3})/.test(val.toString())) {
    val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
  }
  return val;
}

function selectGeoCountry(geoCountry, countryCode) {
  return geoCountry === countryCode ? 'selected' : '';
}

function endsWith(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

function scaleImage(url, w, h) {
  var i = url.lastIndexOf('/');

  if (i == -1) {
    return url;
  }

  if (endsWith(url, 'svg')) { // dont scale svg.
    return url;
  }

  if (endsWith(url, 'png') || endsWith(url, 'jpg')) { // replace with webp
    return url.substring(0, i + 1) + w + '_' + h + '_' + url.substring(i + 1, url.length - 3) + 'webp';
  }

  if (endsWith(url, 'jpeg')) { // replace with webp
    return url.substring(0, i + 1) + w + '_' + h + '_' + url.substring(i + 1, url.length - 4) + 'webp';
  }

  return url.substring(0, i + 1) + w + '_' + h + '_' + url.substring(i + 1);
}

function productBuildString(data) {
  var str = '';

  for (var key in data) {
    str += key + ',' + data[key] + ',';
  }
  return str.slice(0, -1);
}

var MD5 = function(string) {

  function RotateLeft(lValue, iShiftBits) {
    return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
  }

  function AddUnsigned(lX, lY) {
    var lX4, lY4, lX8, lY8, lResult;
    lX8 = (lX & 0x80000000);
    lY8 = (lY & 0x80000000);
    lX4 = (lX & 0x40000000);
    lY4 = (lY & 0x40000000);
    lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
    if (lX4 & lY4) {
      return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
    }
    if (lX4 | lY4) {
      if (lResult & 0x40000000) {
        return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
      } else {
        return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
      }
    } else {
      return (lResult ^ lX8 ^ lY8);
    }
  }

  function F(x, y, z) {
    return (x & y) | ((~x) & z);
  }

  function G(x, y, z) {
    return (x & z) | (y & (~z));
  }

  function H(x, y, z) {
    return (x ^ y ^ z);
  }

  function I(x, y, z) {
    return (y ^ (x | (~z)));
  }

  function FF(a, b, c, d, x, s, ac) {
    a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac));
    return AddUnsigned(RotateLeft(a, s), b);
  };

  function GG(a, b, c, d, x, s, ac) {
    a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac));
    return AddUnsigned(RotateLeft(a, s), b);
  };

  function HH(a, b, c, d, x, s, ac) {
    a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac));
    return AddUnsigned(RotateLeft(a, s), b);
  };

  function II(a, b, c, d, x, s, ac) {
    a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac));
    return AddUnsigned(RotateLeft(a, s), b);
  };

  function ConvertToWordArray(string) {
    var lWordCount;
    var lMessageLength = string.length;
    var lNumberOfWords_temp1 = lMessageLength + 8;
    var lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
    var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
    var lWordArray = Array(lNumberOfWords - 1);
    var lBytePosition = 0;
    var lByteCount = 0;
    while (lByteCount < lMessageLength) {
      lWordCount = (lByteCount - (lByteCount % 4)) / 4;
      lBytePosition = (lByteCount % 4) * 8;
      lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount) << lBytePosition));
      lByteCount++;
    }
    lWordCount = (lByteCount - (lByteCount % 4)) / 4;
    lBytePosition = (lByteCount % 4) * 8;
    lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
    lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
    lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
    return lWordArray;
  };

  function WordToHex(lValue) {
    var WordToHexValue = "",
      WordToHexValue_temp = "",
      lByte, lCount;
    for (lCount = 0; lCount <= 3; lCount++) {
      lByte = (lValue >>> (lCount * 8)) & 255;
      WordToHexValue_temp = "0" + lByte.toString(16);
      WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length - 2, 2);
    }
    return WordToHexValue;
  };

  function Utf8Encode(string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";

    for (var n = 0; n < string.length; n++) {

      var c = string.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }

    }

    return utftext;
  };

  var x = Array();
  var k, AA, BB, CC, DD, a, b, c, d;
  var S11 = 7,
    S12 = 12,
    S13 = 17,
    S14 = 22;
  var S21 = 5,
    S22 = 9,
    S23 = 14,
    S24 = 20;
  var S31 = 4,
    S32 = 11,
    S33 = 16,
    S34 = 23;
  var S41 = 6,
    S42 = 10,
    S43 = 15,
    S44 = 21;

  string = Utf8Encode(string);

  x = ConvertToWordArray(string);

  a = 0x67452301;
  b = 0xEFCDAB89;
  c = 0x98BADCFE;
  d = 0x10325476;

  for (k = 0; k < x.length; k += 16) {
    AA = a;
    BB = b;
    CC = c;
    DD = d;
    a = FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
    d = FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
    c = FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
    b = FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
    a = FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
    d = FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
    c = FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
    b = FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
    a = FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
    d = FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
    c = FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
    b = FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
    a = FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
    d = FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
    c = FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
    b = FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
    a = GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
    d = GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
    c = GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
    b = GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
    a = GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
    d = GG(d, a, b, c, x[k + 10], S22, 0x2441453);
    c = GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
    b = GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
    a = GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
    d = GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
    c = GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
    b = GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
    a = GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
    d = GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
    c = GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
    b = GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
    a = HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
    d = HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
    c = HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
    b = HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
    a = HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
    d = HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
    c = HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
    b = HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
    a = HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
    d = HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
    c = HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
    b = HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
    a = HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
    d = HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
    c = HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
    b = HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
    a = II(a, b, c, d, x[k + 0], S41, 0xF4292244);
    d = II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
    c = II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
    b = II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
    a = II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
    d = II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
    c = II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
    b = II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
    a = II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
    d = II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
    c = II(c, d, a, b, x[k + 6], S43, 0xA3014314);
    b = II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
    a = II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
    d = II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
    c = II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
    b = II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
    a = AddUnsigned(a, AA);
    b = AddUnsigned(b, BB);
    c = AddUnsigned(c, CC);
    d = AddUnsigned(d, DD);
  }

  var temp = WordToHex(a) + WordToHex(b) + WordToHex(c) + WordToHex(d);

  return temp.toLowerCase();
};

function isCryptoCurrency(currency) {
  if (currency === undefined) {
    currency = getCurrency();
  }

  return currency === 'BTC' || currency === 'BCH' || currency === 'ETH' || currency === 'LTC' || currency === 'XDG' || currency === 'XAUT' || currency === 'PAXG';
}

function isSVFCurrency(currency) {
  if (currency === undefined) {
    currency = getCurrency();
  }

  return currency === 'SGD' || currency === 'USD' || currency === 'EUR' || currency === 'GBP' || currency === 'NZD' || currency === 'AUD' || currency === 'JPY' || currency === 'SEK';
}

function getLocation() {
  return locationId;
}

function setLocation(locId, locationShortName) {
  $('#header-location').val(locId);
  changeLocation(locId, locationShortName);
}

function addAffiliateParameters(data) {
  var aid = readCookie('aid');
  if (!aid) {
    aid = -1;
  }
  var aTag = readCookie('atag');
  if (!aTag) {
    aTag = "";
  }
  var blog = readCookie('blog');
  if (!blog) {
    blog = '';
  }
  var post = readCookie('post');
  if (!post) {
    post = '';
  }
  var ref = readCookie('ref');
  if (!ref) {
    ref = '';
  }
  var refNote = readCookie('refNote');
  if (!refNote) {
    refNote = '';
  }

  data['aid'] = aid;
  data['aTag'] = aTag;
  data['blog'] = blog;
  data['post'] = post;
  data['ref'] = urldecode(ref);
  data['refNote'] = refNote;
}

function urldecode(str) {
  return decodeURIComponent((str + '').replace(/\+/g, '%20'));
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

var user = 'support';
domain = 'bullionstar.com';
$('.bullionstar-email').html(user + '@' + domain);
$('.bullionstar-email-enquiry-link').attr('href', 'mailto:' + user + '@' + domain + '?subject=Enquiry%20to%20BullionStar');


var userMedia = 'media';
$('.media-bullionstar-email').html(userMedia + '@' + domain);
$('.media-bullionstar-email-enquiry-link').attr('href', 'mailto:' + userMedia + '@' + domain + '?subject=Media%20Enquiry%20to%20BullionStar');

// Used in buycheckout/vaultwithdraw/vaultsell page
function silentClickRadio(target, id) {
  // Update radio bytton silently (meaning without triggering click event to avoid another api call)
  // Hide all target description
  $('#' + target + '-' + id).parents('.' + target).find('.radio-description').addClass('hide');
  // Checked the target radio button
  $('#' + target + '-' + id).prop('checked', true);
  // Show the target radio button description
  $('#' + target + '-' + id).parent('.radio').next().removeClass('hide');
}

// Used in buycheckout/vaultwithdraw/vaultsell page
function silentClickRadioOneLine(target, id) {
  // Update radio bytton silently (meaning without triggering click event to avoid another api call)
  // Hide all target description
  $('#' + target + '-' + id).parents('.' + target).find('.radio-description').addClass('hide');
  // Checked the target radio button
  $('#' + target + '-' + id).prop('checked', true);
  // Show the target radio button description
  $('#' + target + '-' + id).parent('.radio-one-line').next().removeClass('hide');
}

function showHideBranchCode(res) {
  for (var id in res.paymentMethods) {
    var pm = res.paymentMethods[id];
    for (var fid in pm.fields) {
      if (pm.fields.hasOwnProperty(fid)) {
        var f = pm.fields[fid];

        if (f.visibleByOption.length > 0) {
          $('#' + f.visibleByOption).change(f, function(e) {
            var v = $(this).val();
            var found = false;
            for (var p = 0; p < e.data.visibleByOptionValues.length; p++) {
              if (e.data.visibleByOptionValues[p] == v) {
                found = true;
              }
            }

            var f = $('input[data-name="' + e.data.name + '"]');
            if (found) {
              f.closest('.form-field').show();
            } else {
              f.closest('.form-field').hide();
            }
          }).trigger('change');
        }
      }
    }
  }
}

function getFilterYearPlusOne() {
  var yearNow = moment().year();
  var nextYear = yearNow + 1;
  return checkDateRange(yearNow + '-12-01', nextYear + '-11-30') ? nextYear : yearNow;
}

function checkDateRange(startDate, endDate) {
  var now = moment();
  var DATE_FORMAT = 'YYYY-MM-DD';
  startDate = moment(startDate, DATE_FORMAT);
  endDate = moment(endDate, DATE_FORMAT);

  return now.toDate().getTime() >= startDate.toDate().getTime() && now.toDate().getTime() <= endDate.toDate().getTime();
}

function hasLoggedInId() {
  var name = localStorage.getItem('logged-in-name');
  if (name == null) {
    return false;
  }
  return true;
}

function isLoggedIn() {
  return getAccountId().length > 0;
}

function getAccountIdParameter() {
  var id = localStorage.getItem('logged-in-id');
  if (id == null) {
    return '';
  }

  return '&accountId=' + id;
}

function getAccountId() {
  var id = localStorage.getItem('logged-in-id');
  if (id == null) {
    return '';
  }

  return id;
}

function parseQuantityNotNull(quantityString) {
  var q = parseQuantity(quantityString);
  if (q != null) {
    return q;
  } else {
    return 0;
  }
}

function parseQuantity(quantityString) {
  if (quantityString == null) {
    return null;
  }

  quantityString = quantityString.trim();
  if (quantityString.length == 0) {
    quantityString = '0';
  }

  var quantity = parseInt(quantityString, 10);
  if (isNaN(quantity)) {
    return null;
  }

  return quantity;
}

function getPriceRangeApg(priceRange, apg, currency) {
  if (priceRange == null) {
    return {
      min: 0,
      max: 0,
      prices: {}
    };
  }

  //var a = getPriceRangeByApg(priceRange, apg);

  if (priceRange[currency] == null) {
    currency = 'SGD';
  }

  return priceRange[currency];
}

function getPriceRange(priceRange, currency) {
  if (priceRange == null) {
    return {
      min: 0,
      max: 0,
      prices: {}
    };
  }

  if (priceRange[currency] == null) {
    currency = 'SGD';
  }

  if (priceRange[currency] == null) {
    return {
      min: 0,
      max: 0,
      prices: {}
    };
  }

  return priceRange[currency];
}

function getPriceRangeByApg(priceRange, apg) {
  if (priceRange[apg] == null) {
    apg = 'default';
  }

  return priceRange[apg];
}

var currentApg = null;

function setApg(apg) {
  currentApg = apg;
  // createCookie('apg', currentApg, 1);
  localStorage.setItem('apg', currentApg);
}

function removeApg() {
  localStorage.removeItem('apg');
}

function getApgId() {

  var apg = -1;
  var storedApg = localStorage.getItem('apg');

  apg = storedApg == null || storedApg == '' ? -1 : parseInt(storedApg)

  if (isNaN(apg)) return -1

  return apg;
}

function getApgString() {
  var apg = getApgId();

  if (apg == -1) {
    return 'default';
  }

  return '' + apg;
}

function isApgDefault() {
  return getApgString() == 'default';
}

function getCT() {
  var token = $('body').attr('bssec');
  return token;
}

function isPromoProduct(product) {
  var time = new Date().getTime();
  return product != null && product.promoExpireDate != null && product.promoExpireDate > time && product.promoPrice != null;
}

function isElementInViewport(el, vwThreshold) {
  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }

  var rect = el.getBoundingClientRect(),
    vwThreshold = vwThreshold || 3;

  /* x3 will load more images thrice the size of the viewport */
  return rect.bottom > 0 &&
    rect.right > 0 &&
    rect.left < (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */ &&
    rect.top < ((window.innerHeight || document.documentElement.clientHeight) * vwThreshold) /* or $(window).height() */ ;
}

function addProductRequiredParams() {
  return '&currency=' + getCurrency() + '&apg=' + getApgId() + '&locationId=' + getLocation();
}

function arraysEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) return false;
  for (var i = arr1.length; i--;) {
    if (String(arr1[i]) !== String(arr2[i]))
      return false;
  }
  return true;
}

function ellipsis(str, count, useWordBoundary) {
  if (str.length <= count) {
    return str;
  }
  var subString = str.substr(0, count - 1);
  return (useWordBoundary ? subString.substr(0, subString.lastIndexOf(' ')) : subString) + '...';
}

function generateChangeCryptoCurrencyTitle(cryptoCur) {
  return 'Currency Changed to ' + cryptoCur;
}

function generateChangeCryptoCurrencyMessage(cryptoCur, mobile) {
  return 'Please note that the currency has been changed to ' + cryptoCur + '.' + ((mobile) ? '' : ' To view other payment options, please change currency on the top right hand side of the website.');
}

var lastUserErrorReportMessage = '';

function sendUserErrorReport(type, message) {
  if (message === lastUserErrorReportMessage) {
    return;
  }

  lastUserErrorReportMessage = message;

  new Request(servicesSGUrl + '/api/v1/usererrorreporting/report', {
    type: type,
    message: message
  }).send();
}

function isValidDate(dateString, validStartDate, useToDate) {
  validStartDate = validStartDate || '';
  useToDate = useToDate || false;

  if (dateString === '') {
    return {
      error: false
    }
  }
  // First check for the pattern
  if (!/^\d{2}\-\d{2}\-\d{4}$/.test(dateString)) {
    return {
      error: true,
      type: 'format',
      message: 'Please use the DD-MM-YYYY date format for custom period start and end date.'
    };
  }

  var date = parseDateString(dateString);

  var lastYearValid = validStartDate.split('-')[0] || 1900;
  var d = new Date();
  var presentYear = d.getFullYear();

  if (date.year < lastYearValid || // Check for year lower than min year
    date.year > presentYear || // Check for year higher than max year
    date.month == 0 || // Check invalid month
    date.month > 12) { // Check invalid month
    return {
      error: true,
      type: 'nodata',
      message: useToDate ? 'There is no data available for the selected end date. The end date has been changed to today\'s date' : 'There is no data available for the selected end date. The end date has been changed to ' + validStartDate + ' which is the first date for which data is available.'
    };
  }

  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Adjust for leap years
  if (date.year % 400 == 0 || (date.year % 100 != 0 && date.year % 4 == 0)) {
    monthLength[1] = 29;
  }

  // Check the range of the day
  if (date.day < 1 || date.day > monthLength[date.month - 1]) {
    return {
      error: true,
      type: 'format',
      message: 'Please use the DD-MM-YYYY date format for custom period start and end date.'
    };
  }

  return {
    error: false
  }
}

function parseDateString(str) {
  // Parse the date parts to integers
  var parts = str.split('-'),
    d = parseInt(parts[0], 10),
    m = parseInt(parts[1], 10),
    y = parseInt(parts[2], 10);

  return {
    day: d,
    month: m,
    year: y
  };
}

// Change date format to YYYY-MM-DD
function parseDateStringFormat(str) {
  if (str.length === 0) return '';

  // Parse the date parts to integers
  var parts = str.split('-'),
    d = parseInt(parts[0], 10),
    m = parseInt(parts[1], 10),
    y = parseInt(parts[2], 10);

  // typecast to string for the length check to work
  if (String(d).length === 1) d = '0' + d;
  if (String(m).length === 1) m = '0' + m;

  return y + '-' + m + '-' + d;
}

function timeDiffInHoursMinutesSeconds(timeLeftInSeconds) {
  var hours = parseInt(timeLeftInSeconds / (60 * 60), 10);
  var minutes = parseInt(timeLeftInSeconds / 60 % 60, 10);
  var seconds = parseInt(timeLeftInSeconds % 60, 10);

  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  seconds = seconds < 10 ? '0' + seconds : seconds;

  return {
    hours: hours,
    minutes: minutes,
    seconds: seconds
  }
}

function mapCurrencySymbol(currency) {
  if (currency === 'USD') {
    return '<img src="' + cdnUrl + '/img/d/america-rectangle-icon.svg" />';
  } else if (currency === 'AUD') {
    return '<img src="' + cdnUrl + '/img/d/australia-rectangle-icon.svg" />';
  } else if (currency === 'SGD') {
    return '<img src="' + cdnUrl + '/img/d/singapore-rectangle-icon.svg" />';
  } else if (currency === 'EUR') {
    return '<img src="' + cdnUrl + '/img/d/europe-rectangle-icon.svg" />';
  } else if (currency === 'JPY') {
    return '<img src="' + cdnUrl + '/img/d/japan-rectangle-icon.svg" />';
  } else if (currency === 'SEK') {
    return '<img src="' + cdnUrl + '/img/d/sweden-rectangle-icon.svg" />';
  } else if (currency === 'CNY') {
    return '<img src="' + cdnUrl + '/img/d/china-rectangle-icon.svg" />';
  } else if (currency === 'GBP') {
    return '<img src="' + cdnUrl + '/img/d/british-rectangle-icon.svg" />';
  } else if (currency === 'NZD') {
    return '<img src="' + cdnUrl + '/img/d/new-zealand-rectangle-icon.svg" />';
  } else if (currency === 'CAD') {
    return '<img src="' + cdnUrl + '/img/d/canada-rectangle-icon.svg" />';
  } else if (currency === 'CHF') {
    return '<img src="' + cdnUrl + '/img/d/swiss-rectangle-icon.svg" />';
  } else if (currency === 'HKD') {
    return '<img src="' + cdnUrl + '/img/d/hongkong-rectangle-icon.svg" />';
  } else if (currency === 'MYR') {
    return '<img src="' + cdnUrl + '/img/d/malaysia-rectangle-icon.svg" />';
  } else if (currency === 'INR') {
    return '<img src="' + cdnUrl + '/img/d/india-rectangle-icon.svg" />';
  } else if (currency === 'IDR') {
    return '<img src="' + cdnUrl + '/img/d/indonesia-rectangle-icon.svg" />';
  } else if (currency === 'RUB') {
    return '<img src="' + cdnUrl + '/img/d/russia-rectangle-icon.svg" />';
  } else if (currency === 'BRL') {
    return '<img src="' + cdnUrl + '/img/d/brazil-rectangle-icon.svg" />';
  } else if (currency === 'DKK') {
    return '<img src="' + cdnUrl + '/img/d/denmark-rectangle-icon.svg" />';
  } else if (currency === 'BTC') {
    return '<img src="' + cdnUrl + '/img/bitcoin-v1.svg" width="18" height="20" class="crypto" />';
  } else if (currency === 'BCH') {
    return '<img src="' + cdnUrl + '/img/bitcoincash.svg" width="18" height="20" class="crypto" />';
  } else if (currency === 'ETH') {
    return '<img src="' + cdnUrl + '/img/ethereum.svg" width="18" height="20" class="crypto" />';
  } else if (currency === 'LTC') {
    return '<img src="' + cdnUrl + '/img/litecoin.svg" width="18" height="20" class="crypto" />';
  } else if (currency === 'XDG') {
    return '<img src="' + cdnUrl + '/img/dogecoin.svg" width="18" height="20" class="crypto" />';
  } else if (currency === 'XAUT') {
    return '<img src="' + cdnUrl + '/img/xaut.svg" width="18" height="20" class="crypto" />';
  } else if (currency === 'PAXG') {
    return '<img src="' + cdnUrl + '/img/paxg.svg" width="18" height="20" class="crypto" />';
  } else {
    return '';
  }
}

function showFlag(type) {
  if (type == 'LME') {
    return '<img src="' + cdnUrl + '/img/d/uk-round-icon.svg" width="40">';
  } else if (type == 'LBMA') {
    return '<img src="' + cdnUrl + '/img/d/uk-round-icon.svg" width="40">';
  } else if (type == 'SGE') {
    return '<img src="' + cdnUrl + '/img/d/china-round-icon.svg" width="40">';
  } else if (type == 'JP') {
    return '<img src="' + cdnUrl + '/img/d/japan-round-icon.svg" width="40">';
  } else if (type == 'AU') {
    return '<img src="' + cdnUrl + '/img/d/australia-round-icon.svg" width="40">';
  } else if (type == 'SW') {
    return '<img src="' + cdnUrl + '/img/d/sweden-round-icon.svg" width="40">';
  } else if (type == 'AM') {
    return '<img src="' + cdnUrl + '/img/d/america-round-icon.svg" width="40">';
  } else if (type == 'SG') {
    return '<img src="' + cdnUrl + '/img/d/singapore-round-icon.svg" width="40">';
  }
}

function getCurrencyDecmial(val) {
  if (!val || isNaN(val)) return 0;
  return isAuctionsOverview() ? Math.round(val) : isCryptoCurrency() ? cryptoDecimalPointRules(parseFloat(val)) : parseFloat(val).toFixed(2);
}

// document.addEventListener("DOMContentLoaded", () => {
if ($('.cookiePolicy').length > 0) {
  // setTimeout(() => {
  var cookiesAccepted = localStorage.getItem('cookiesAccepted');
  if (!cookiesAccepted) {
    $('.cookiePolicy').addClass('show');
  }
  // }, 2000);

  // $(document).ready(function () {
  $('.btn-cookie').on('click', function() {
    localStorage.setItem('cookiesAccepted', 1);
    $('.cookiePolicy').removeClass('show');
    $('.wrap').removeClass('overflow-auto');
  });
  // });
}
// });

function currencySelectWithFlag(targetId) {
  var dropdownList = '';
  $.each($(targetId).children(), function(i, option) {
    dropdownList += '<li class="gold-currency-selection' + (option.selected ? ' active' : '') + '" data-currency="' + option.value + '"><span class="symbol">' + mapCurrencySymbol(option.value) + '</span>' + option.text + '</li>';
  });
  var dropdown = '<ul class="currency-dropdown hide">' + dropdownList + '</ul>';

  $(dropdown).insertAfter($(targetId));

  $(targetId).on('mousedown', function(e) {
    e.preventDefault();
    this.blur();
    window.focus();
    $(this).next().toggleClass('hide');
  });

  $(targetId).on('click', function(e) {
    e.stopPropagation();
  });

  $(targetId).parent().find('.gold-currency-selection').on('click', function() {
    $(this).parent().addClass('hide');
    $('.gold-currency-selection').removeClass('active');
    $(this).addClass('active');
    $(targetId + ' option[value="' + $(this).data('currency') + '"]').prop('selected', true).trigger('change');
  });
}

function dontShowFilter() {
  var path = window.location.pathname;
  return path === '/buy/supplies' || path === '/buy/bullion-savings-program' || path === '/buy/palladium';
}

function searchHelpMiss(query) {
  new Request(servicesUrl + '/help/search/miss', {
    query: query
  }).send();
}

function convertArrToString(arr) {
  if (!Array.isArray(arr) || arr.length === 0) return '';
  return arr.join(',');
}

function searchObjectInArray(key, arr) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i].id === key) {
      return arr[i];
    }
  }
  return null;
}

function getVisitedDays() {
  var visitedDays = 0;
  var cookieFirstVisit = localStorage.getItem('firstVisit');
  if (!cookieFirstVisit) return visitedDays;

  var now = new Date(),
    firstVisit = parseInt(cookieFirstVisit);

  var diff = (now / 1000) - firstVisit;

  if (diff > 0) {
    visitedDays = parseInt(diff / (24 * 3600));
  }

  return visitedDays;
}

function getRemainingMinutes(waitingTime, now) {
  return Math.floor((waitingTime - now) / 60000) + 1
}

// Remove id-quantity when not in /buy/product/ page
if (window.location.pathname.indexOf('/buy/product/') !== 0) {
  localStorage.removeItem('id-quantity');
}

// Add startsWIth method
if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, 'startsWith', {
    value: function(search, pos) {
      pos = !pos || pos < 0 ? 0 : +pos;
      return this.substring(pos, pos + search.length) === search;
    }
  });
}

// [data-react-hydrated] chrome (hydrated footer/header) computes its own star
// fill width at render, so skip those — same scoping as the anchor rewriter.
$('.rating-star').not('[data-react-hydrated] .rating-star').each(function() {
  var rating = $(this).data('rating');
  var max = $(this).data('max-rating');
  var width = $(this).data('rating-width');
  $(this).css('width', '' + ((rating / max) * width) + 'px');
});

// Referral
{
  var r = getParameterByName('r');
  console.log('referral: r=' + r);

  var hashTag = window.location.hash ? window.location.hash.substring(1) : null;
  console.log('referral: hashTag=' + "hashTag");

  var oldAid = readCookie('aid');
  var oldAtag = readCookie('atag');
  console.log('referral: oldAid=' + oldAid + ' referral: oldAtag=' + oldAtag);

  // If aid already exists, skip everything
  if (oldAid && !isNaN(parseInt(oldAid)) && parseInt(oldAid) > 0) {
    console.log('referral: aid already set');
  }
  // Else if atag already exists, skip everything
  else if (oldAtag && isNaN(oldAtag) && oldAtag !== '') {
    console.log('referral: atag already set');
  }
  // Else set aid if valid
  else if (r) {
    var aid = parseInt(r);
    console.log('referral: aid=' + aid);
    if (!isNaN(aid) && aid > 0) {
      console.log('referral: setting aid to: ' + aid);
      createCookie('aid', aid, getAffiliateCookieValidDays(aid), 1, accessTokenDomain);
      createCookie('refNote', 'r parameter set to ' + aid, getAffiliateCookieValidDays(aid), 1, accessTokenDomain);
    }
  }
  // Else set atag if valid
  else if (hashTag && isNaN(hashTag) && hashTag !== '') {
    var atag = hashTag;
    console.log('referral: atag=' + atag);
    console.log('referral: setting atag to: ' + atag);
    createCookie('atag', atag, getAffiliateCookieValidDays(atag), 1, accessTokenDomain);
    createCookie('refNote', 'hashTag set to ' + atag, getAffiliateCookieValidDays(atag), 1, accessTokenDomain);
  }

  console.log('checking if ref cookie is set');
  if (!readCookie('ref')) {
    console.log('referral: setting ref to: ' + document.referrer);
    createCookie('ref', document.referrer, 30, 1, accessTokenDomain);
  }

  if (document.referrer && (!readCookie('aid') || readCookie('aid') == -1)) {
    console.log('calling affiliateIdCheck');
    $.ajax({
      url: servicesUrl + '/affiliate/affiliateIdCheck',
      type: 'post',
      dataType: 'json',
      data: {
        referrerUrl: document.referrer
      },
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      processData: true,
      headers: {
        'requestId': uuidv4()
      },
      xhrFields: {
        withCredentials: true
      },
      success: function(json) {
        console.log(json);
        if (json.affiliateId > 0) {
          createCookie('ref', document.referrer, getAffiliateCookieValidDays(json.affiliateId), 1, accessTokenDomain);
          if (json.refNote != null && json.refNote.length > 0) {
            createCookie('refNote', json.refNote, 30, 1, accessTokenDomain);
          } else {
            createCookie('refNote', document.referrer + ' gave affiliate: ' + json.affiliateId, 30, 1, accessTokenDomain);
          }
        }

        createCookie('aid', json.affiliateId, getAffiliateCookieValidDays(json.affiliateId), 1, accessTokenDomain);

      },
      error: function(json) {
        console.warn(json);
      }
    });
  }

  if (!readCookie('blog')) {
    createCookie('blog', blog, 30, 1, accessTokenDomain);
    if (!readCookie('post')) {
      createCookie('post', post, 30, 1, accessTokenDomain);
    }
  }

}

function getParameterByName(name) {
  var url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function getMachineId() {
  var machineId = localStorage.getItem('machineId');
  if (machineId && machineId.length > 0) {
    console.log('machineId in local storage: ' + machineId);
    return machineId;
  }

  var machineId = readCookie('m');
  if (machineId && machineId.length > 0) {
    console.log('machineId found as cookie: ' + machineId);
    localStorage.setItem('machineId', machineId);
    return machineId;
  }

  machineId = makeid(20);
  console.log('machineId not found. Created: ' + machineId);
  localStorage.setItem('machineId', machineId);

  return machineId;
}

function makeid(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

{
  var fv = localStorage.getItem('firstVisit');
  if (!fv) {
    var now = Math.round(new Date().getTime() / 1000);
    console.log('(1) setting firstVisit: ' + now);
    localStorage.setItem('firstVisit', now);
  }
}

function checkExpireDate(timeLeft) {
  return new Date().getTime() / 1000 + timeLeft;
}

function log(msg) {
  console.log('%c' + msg, 'font-size: 14px; color: cornflowerblue');
}

// ==================== CREDIT CARD

var ccExpMonth = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function append0ToMonth(n) {
  var num = '' + n;
  return num.length === 1 ? '0' + n : n
}

var cachedMonth = $('#credit-card-exp-mm').val() // Remember the previously selected month
var cachedYear; // Remember the previously selected month
var cachedCCNumber;
var cachedCVV;

function getCreditCardValidMonth(currMonth) {
  var date = new Date();
  currMonth = currMonth || date.getMonth() + 1;
  var optionsHtml = '';
  for (var x = 0; x <= ccExpMonth.length; x++) {
    if (currMonth <= ccExpMonth[x]) {
      optionsHtml += '<option value="' + ccExpMonth[x] + '" ' + (x == (cachedMonth - 1) ? 'selected="true"' : '') + '>' + append0ToMonth(ccExpMonth[x]) + '</option>'
    }
  }
  return optionsHtml;
}

function getCreditCardValidYear() {
  var date = new Date();
  var currYear = date.getFullYear().toString();
  var nextYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
  var compareYear = cachedYear ? cachedYear : nextYear.getFullYear()
  var optionsHtml = '';
  for (var x = 0; x <= 20; x++) {
    var year = parseInt(currYear) + x;
    optionsHtml += '<option value="' + year + '"' + (compareYear == year ? 'selected="true"' : '') + '>' + year + '</option>'
  }

  return optionsHtml;
}

function loadCreditCard() {
  var $ccExpMM = $('#credit-card-exp-mm');
  var $ccExpYYYY = $('#credit-card-exp-yy');

  $ccExpMM.html(getCreditCardValidMonth('00'));
  $ccExpYYYY.html(getCreditCardValidYear());

  $ccExpMM.off().on('change', function() {
    cachedMonth = $(this).val();
  })

  $ccExpYYYY.off().on('change', function() {
    var date = new Date();
    var currYear = date.getFullYear().toString();
    var param = ($(this).val() > currYear) ? '00' : '';
    cachedMonth = $ccExpMM.val()
    $ccExpMM.html(getCreditCardValidMonth(param));
    cachedYear = $(this).val();
  })

  $ccExpYYYY.trigger('change')

  $('input[data-input-type="creditcard-number"]').off().on('input', function() {
    cachedCCNumber = $(this).val();
  });

  $('input[data-input-type="creditcard-exp-cvv"]').off().on('input', function() {
    cachedCVV = $(this).val();
  });
}

// ==================== CREDIT CARD

function getOldPaymentMethodId(paymentMethodIdsArray) {
  return paymentMethodIdsArray.length ? paymentMethodIdsArray[paymentMethodIdsArray.length - 1] : null
}

function getOldAutoInvestFrequencyId(oldAutoInvestFrequencyIdsArray) {
  return oldAutoInvestFrequencyIdsArray.length ? oldAutoInvestFrequencyIdsArray[oldAutoInvestFrequencyIdsArray.length - 1] : null
}

function getOldShippingMethodId(shippingMethodIdsArray) {
  return shippingMethodIdsArray.length ? shippingMethodIdsArray[shippingMethodIdsArray.length - 1] : null
}

function isShipping(shippingId) {
  return shippingId === 1 || shippingId === 5 || shippingId === 8; // 1 = Shipping SG, 5 = Shipping NZ, 8 = Shipping by FedEx (US)
}

var deferredA2HSPrompt;
var $wrapA2HS = $('.a2hs-wrap');
var $btnA2HS = $('.btn-a2hs');

window.addEventListener('beforeinstallprompt', function(e) {
  e.preventDefault();
  deferredA2HSPrompt = e;
  if (readCookie('a2hs') && readCookie('a2hs') == 1) {
    $wrapA2HS.addClass('hide')
  } else {
    $wrapA2HS.removeClass('hide')
  }
});

$btnA2HS.on('click', function(e) {
  $wrapA2HS.addClass('hide')
  deferredA2HSPrompt.prompt();
  deferredA2HSPrompt.userChoice.then(function(choiceResult) {
    if (choiceResult.outcome === 'accepted') {
      console.log('User accepted the A2HS prompt');
      $wrapA2HS.addClass('hide')
    } else {
      console.log('User dismissed the A2HS prompt');
    }
    deferredA2HSPrompt = null;
  }).catch(function(err) {
    console.log(err)
    deferredA2HSPrompt = null;
  });
});

$('.close-a2hs').on('click', function(e) {
  e.stopPropagation();
  $wrapA2HS.addClass('hide');
  createCookie('a2hs', 1, 365);

  if (sessionStorage.getItem('close-a2hs') === '1') return;

  var data = isLoggedIn() ? {
    accountId: getAccountId()
  } : {};

  var req = new Request(servicesSGUrl + '/api/v1/tracking/track?key=CLOSE-INSTALL-POPUP', data)

  req.success(function(res) {
    console.log(res)
    sessionStorage.setItem('close-a2hs', '1');
  })

  req.send();
});

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/sw.js')
    .then(function() {
      console.log("Service Worker Registered");
    });
}

window.addEventListener('appinstalled', (evt) => {
  // Log install to analytics
  console.log('INSTALL: Success');

  if (sessionStorage.getItem('install-a2hs') === '1') return;

  var data = isLoggedIn() ? {
    accountId: getAccountId()
  } : {};

  var req = new Request(servicesSGUrl + '/api/v1/tracking/track?key=INSTALL-APP', data)

  req.success(function(res) {
    console.log(res)
    sessionStorage.setItem('install-a2hs', '1');
  })

  req.send();
});

window.addEventListener('DOMContentLoaded', () => {
  let displayMode = 'browser tab';
  if (navigator.standalone) {
    displayMode = 'standalone-ios';
  }
  if (window.matchMedia('(display-mode: standalone)').matches) {
    displayMode = 'standalone';

    if (sessionStorage.getItem('open-a2hs-1') === '1') return;

    var data = isLoggedIn() ? {
      accountId: getAccountId()
    } : {};

    var req = new Request(servicesSGUrl + '/api/v1/tracking/track?key=OPEN-APP', data)

    req.success(function(res) {
      console.log(res)
      console.log('DISPLAY_MODE_LAUNCH:', displayMode);
      sessionStorage.setItem('open-a2hs-1', '1');
    })

    req.send();
  }
});

window.matchMedia('(display-mode: standalone)').addListener((evt) => {
  let displayMode = 'browser tab';
  if (evt.matches) {
    displayMode = 'standalone';

    if (sessionStorage.getItem('open-a2hs-1') === '2') return;

    var data = isLoggedIn() ? {
      accountId: getAccountId()
    } : {};

    var req = new Request(servicesSGUrl + '/api/v1/tracking/track?key=OPEN-APP', data)

    req.success(function(res) {
      console.log(res)
      console.log('DISPLAY_MODE_LAUNCH:', displayMode);
      sessionStorage.setItem('open-a2hs-2', '1');
    })

    req.send();
  }
});

function get400ozPrice() {
  var req = new Request(servicesUrl + '/product/v2/prices', {
    currency: getCurrency(),
    locationId: 1,
    productIds: '3216',
  });
  req.type('get');
  req.success(function(res) {
    $('.price-400-oz').html(res.products[0].price)
  });

  req.send();
}

function cryptoDecimalPointRules(num) {
  if (!isCryptoCurrency()) return num

  if (getCurrency() === 'XDG') {
    return num.toFixed(4)
  }
  return num.toFixed(8)

}

// Remove filterProductOptions when not in /buy/ page
if (window.location.pathname.indexOf('/buy/') !== 0) {
  localStorage.removeItem('filterProductJewelleryOptionIds');
  localStorage.removeItem('filterProductOptionIds');
}

var fakeUploadProgressBarID = null

function resetUploadProgressBar() {
  clearInterval(fakeUploadProgressBarID)
  $('.popup-document-upload .bar').css('width', '0%');
}

function fullUploadProgressBar() {
  clearInterval(fakeUploadProgressBarID)
  $('.popup-document-upload .bar').css('width', '100%');
}

function fakeUploadProgressBar() {
  var currentProgress = 0;
  var step = 0.7;

  fakeUploadProgressBarID = setInterval(function() {
    currentProgress += step;
    progress = Math.round(Math.atan(currentProgress) / (Math.PI / 2) * 100 * 1000) / 1000
    $('.popup-document-upload .bar').css('width', progress + '%');
    if (progress >= 100) {
      clearInterval(fakeUploadProgressBarID);
    } else if (progress >= 70) {
      step = 0.1
    }
  }, 100);
}

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

function changeCountryFields() {
  $('.country-select').val(getGeoCountry());
  $('.country-select').trigger('change');
  $('.country-code-selection').val(getGeoCountry());
  $('.country-code-selection').trigger('change');
  checkCountryStateFields();
}

function checkCountryStateFields() {
  $('.trigger-show-other-field').each(function(idx, el) {
    var $triggerFullnameField = $(el);
    var $parentJointField = $triggerFullnameField.closest('.form');
    if ($triggerFullnameField.val().length === 0) {
      $parentJointField.find('.state-form-field').addClass('hide');
      $parentJointField.find('.state-form-select-field').addClass('hide');
      // $parentJointField.find('.country-form-field').addClass('hide');
    }
  });
}

function changeBuyCheckoutCountryFieldsToDefaultSG() {
  console.log('User country is high risk! Defaulting to SG');
  $('.country-select').val('SG')
  $('.country-select option[value=SG]').prop('selected', true);
  $('.country-select').trigger('change');
  $('.country-code-selection option[value=SG]').prop('selected', true);
  $('.country-code-selection').trigger('change'); // To force change in country code
}

function changeSellCheckoutCountryFieldsToDefaultSG() {
  console.log('User country is high risk! Defaulting to SG');
  $('#country option[value=SG]').prop('selected', true);
  $('.country-select').trigger('change');
  $('#country-code-selection option[value=SG]').prop('selected', true);
  $('#country-code-selection').trigger('change'); // To force change in country code
}

function removeHash() {
  var hash = window.location.hash;
  if (hash) {
    if (hash.includes('jwt=')) {
      history.pushState(null, document.title, window.location.pathname + window.location.search);
    }
  }
}

function getValuation() {
  var v = readCookie('valuation-method');
  if (v == null) {
    return 'buy';
  }

  if (v === '1') {
    return 'sell';
  } else if (v === '2') {
    return 'spot';
  } else {
    return 'buy';
  }
}

function isMyAccountAuctionsPage() {
  return window.location.pathname === '/myaccount/auctions';
}

function isAuctionsOverview() {
  return window.location.pathname === '/auctions/' || isMyAccountAuctionsPage();
}

function getAffiliateCookieValidDays(aid) {
  if (aff[aid] === undefined) {
    return 30;
  } else {
    return aff[aid];
  }
}

// to prevent scroll in input type number fields
document.addEventListener("wheel", function() {
  if (document.activeElement.type === "number") {
    document.activeElement.blur();
  }
});

// vault page open account link hode for logged in user
function hideVaultPageOpenAccountLink(loggedIn) {
  let loggedInName = localStorage.getItem('logged-in-name');

  if (loggedIn === undefined) {
    if (loggedInName && loggedInName.length > 0) {
      loggedIn = true;
    } else {
      loggedIn = false;
    }
  }
  console.log(loggedIn)
  let storageOverviewTxt = document.getElementById('storage-overview').textContent;
  if (loggedIn) {
    document.getElementById('storage-overview').innerHTML = storageOverviewTxt;
  } else {
    document.getElementById('storage-overview').innerHTML = "Quick & easy to <a href='/createaccount' id='vault-open-account'>open an account</a>";
  }
}

function sanitizeXSS(input) {
  // Remove HTML characters
  let sanitized = input.replace(/<[^>]*>?/gm, '');

  // Strip PHP tags
  sanitized = sanitized.replace(/<\?php[\s\S]*?\?>/g, '');

  return sanitized;
}

$('.shipping-vault-tab-wrap > .tabs > li').on('click', function() {
  var _this = $(this);

  $('.shipping-vault-tab-wrap > .tabs > li').removeClass('active');
  _this.addClass('active');
  $('.shipping-vault-tab-wrap .opening').addClass('hide')
  if (_this.hasClass('shipping')) {
    $('.shipping-vault-tab-wrap .opening.shipping').removeClass('hide')
    $('.shipping-vault-body > .right.desktop.shipping').removeClass('hide')
    $('.shipping-vault-body > .right.desktop.vault').addClass('hide')
    $('.shipping-vault-body > .right.tablet.shipping').removeClass('hide')
    $('.shipping-vault-body > .right.tablet.vault').addClass('hide')
    $('.shipping-vault-body > .right-us.desktop.shipping').removeClass('hide')
    $('.shipping-vault-body > .right-us.desktop.vault').addClass('hide')
    $('.shipping-vault-body > .right-us.tablet.shipping').removeClass('hide')
    $('.shipping-vault-body > .right-us.tablet.vault').addClass('hide')
  } else {
    $('.shipping-vault-tab-wrap .opening.vault').removeClass('hide')
    $('.shipping-vault-body > .right.desktop.vault').removeClass('hide')
    $('.shipping-vault-body > .right.desktop.shipping').addClass('hide')
    $('.shipping-vault-body > .right.tablet.vault').removeClass('hide')
    $('.shipping-vault-body > .right.tablet.shipping').addClass('hide')
    $('.shipping-vault-body > .right-us.desktop.vault').removeClass('hide')
    $('.shipping-vault-body > .right-us.desktop.shipping').addClass('hide')
    $('.shipping-vault-body > .right-us.tablet.vault').removeClass('hide')
    $('.shipping-vault-body > .right-us.tablet.shipping').addClass('hide')
  }
});
$('.shipping-vault-tab-wrap > .tabs > li.shipping').addClass('active');

var pageInfo = (function() {
  return {
    'requestUri': window.location.pathname,
    'searchParams': function(key) {
      return (new URL(document.location)).searchParams; // returns URLSearchParams object
    }
  };
})();

function addCoupon(coupon) {
  var coupons = getCoupons();
  console.log('parsed coupons');
  console.log(coupons);
  if (!hasCoupon(coupons, coupon)) {
    coupons.push({
      name: coupon,
      awardDateTime: Date.now()
    });
    console.log('!hasCoupon adding. coupons.length after: ' + coupons.length);
    var couponString = createCouponString(coupons);
    localStorage.setItem('coupons', couponString);
  } else {
    console.log('already has coupon: ' + coupon);
  }
}

function hasCoupon(coupons, coupon) {
  for (var i = 0; i < coupons.length; i++) {
    if (coupons[i].name == coupon) {
      return true;
    }
  }

  return false;
}

function getCouponString() {
  var couponString = localStorage.getItem('coupons');
  if (couponString) {
    return couponString;
  }

  return '';
}

function getCoupons() {
  var couponString = getCouponString();
  if (couponString.length == 0) {
    return [];
  }

  return JSON.parse(couponString);
}

function createCouponString(coupons) {
  return JSON.stringify(coupons);
}

if (getLocation() != '1') {
  localStorage.removeItem('cart1');
}
if (getLocation() != '2') {
  localStorage.removeItem('cart2');
}
if (getLocation() != '3') {
  localStorage.removeItem('cart3');
}